<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <chart-legend :element="element"></chart-legend>
      <chart-grid :element="element"></chart-grid>
      <chart-draw :element="element">
        <template #default>
          <el-form-item label="方向">
            <el-button-group>
              <el-button size="small" @click="transverse()">横向</el-button>
              <el-button size="small" @click="vertical()">竖向</el-button>
            </el-button-group>
          </el-form-item>

          <el-form-item label="堆叠">
            <el-button-group>
              <el-button size="small" @click="handleChangeStack(0)">关闭</el-button>
              <el-button size="small" @click="handleChangeStack(1)">堆叠</el-button>
              <el-button size="small" @click="handleChangeStack(2)">堆叠(包含)</el-button>
            </el-button-group>
          </el-form-item>

        </template>
      </chart-draw>
      <chart-x-axis :element="element"></chart-x-axis>
      <chart-y-axis :element="element"></chart-y-axis>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartLegend from "@/components/design-report/chart/chartStyle/chartLegend.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";
import ChartGrid from "@/components/design-report/chart/chartStyle/chartGrid.vue";
import ChartXAxis from "@/components/design-report/chart/chartStyle/chartXAxis.vue";
import ChartYAxis from "@/components/design-report/chart/chartStyle/chartYAxis.vue";
import ChartDraw from "@/components/design-report/chart/chartStyle/chartDraw.vue";

export default {
  components: {ChartDraw, ChartYAxis, ChartXAxis, ChartGrid, ChartSubTitle, ChartLegend, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
    transverse() {
      delete this.ele.option.xAxis.type
      this.ele.option.yAxis.type = 'category'

      this.ele.option.xAxis = this.deepClone(this.element.option.xAxis)
      this.ele.option.yAxis = this.deepClone(this.element.option.yAxis)
    },
    vertical() {
      delete this.ele.option.yAxis.type
      this.ele.option.xAxis.type = 'category'

      this.ele.option.xAxis = this.deepClone(this.element.option.xAxis)
      this.ele.option.yAxis = this.deepClone(this.element.option.yAxis)
    },
    handleChangeStack(value) {

      this.ele.option.stackOption = value;

      this.ele.option.series.forEach(item => {
        delete item.stack;
        delete item.barGap;
      })

      if (value === 1) {
        this.ele.option.series.forEach(item => item.stack = true)
      } else if (value === 2) {
        this.ele.option.series.forEach(item => item.barGap = "-100%");
      }

      this.ele.option.series = this.deepClone(this.ele.option.series)
    },
  }


}

</script>

<style scoped lang="scss">

</style>